import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie_consent_v2";

function grantAnalytics() {
  if (window.gtag) window.gtag("consent", "update", { analytics_storage: "granted" });
}

// Conversii + remarketing/reclame personalizate (Google, Meta, LinkedIn)
function grantMarketing() {
  if (window.gtag) window.gtag("consent", "update", { ad_storage: "granted", ad_user_data: "granted", ad_personalization: "granted" });
  // Meta Pixel + LinkedIn Insight — se incarca doar acum, niciodata inainte de accept
  if (window.__loadMarketingPixels) window.__loadMarketingPixels();
}

export default function CookieBanner() {
  const [visible, setVisible]       = useState(false);
  const [expanded, setExpanded]     = useState(false);
  const [analyticsOn, setAnalytics] = useState(true);
  const [marketingOn, setMarketing] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
      return;
    }
    try {
      const prefs = JSON.parse(stored);
      if (prefs.analytics) grantAnalytics();
      if (prefs.marketing) grantMarketing();
    } catch (e) {}
  }, []);

  const save = (analytics, marketing) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ essential: true, analytics, marketing }));
    if (analytics) grantAnalytics();
    if (marketing) grantMarketing();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: "rgba(8,18,36,0.98)", borderTop: "1px solid rgba(255,255,255,0.1)",
      backdropFilter: "blur(16px)", boxShadow: "0 -4px 24px rgba(0,0,0,0.4)",
    }}>
      {/* Zona principală */}
      <div style={{
        maxWidth: 900, margin: "0 auto", padding: "18px 24px",
        display: "flex", alignItems: "center", gap: 20, flexWrap: "wrap",
      }}>
        <div style={{ flex: 1, minWidth: 260 }}>
          <p style={{ margin: "0 0 4px", color: "#e6e8ee", fontSize: 14, fontWeight: 600 }}>
            🍪 Preferințe cookie-uri
          </p>
          <p style={{ margin: 0, color: "rgba(203,213,225,0.75)", fontSize: 13, lineHeight: 1.5 }}>
            Folosim cookie-uri esențiale (necesare) și, cu acordul tău, Google Analytics și cookie-uri de marketing (conversii + remarketing) pentru a înțelege cum este folosit site-ul.{" "}
            <Link to="/cookies" style={{ color: "#93c5fd", textDecoration: "underline" }}>
              Politica de cookies
            </Link>
          </p>
        </div>

        <div style={{ display: "flex", gap: 10, flexShrink: 0, flexWrap: "wrap", alignItems: "center" }}>
          <button
            onClick={() => setExpanded(v => !v)}
            style={{
              background: "transparent", color: "rgba(203,213,225,0.7)",
              border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8,
              padding: "9px 16px", fontSize: 13, cursor: "pointer",
            }}
          >
            {expanded ? "Ascunde detalii ▲" : "Personalizează ▼"}
          </button>
          <button
            onClick={() => save(false, false)}
            style={{
              background: "transparent", color: "#e6e8ee",
              border: "1px solid rgba(255,255,255,0.25)", borderRadius: 8,
              padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer",
            }}
          >
            Doar esențiale
          </button>
          <button
            onClick={() => save(true, true)}
            style={{
              background: "#2B36A8", color: "#fff", border: "none",
              borderRadius: 8, padding: "9px 22px", fontSize: 13,
              fontWeight: 700, cursor: "pointer",
            }}
          >
            Acceptă tot
          </button>
        </div>
      </div>

      {/* Panou detalii granulare */}
      {expanded && (
        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(255,255,255,0.03)",
          padding: "16px 24px 20px",
          maxWidth: 900, margin: "0 auto",
        }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

            {/* Esențiale — mereu active */}
            <div style={{
              display: "flex", alignItems: "flex-start", justifyContent: "space-between",
              gap: 16, padding: "12px 16px",
              background: "rgba(255,255,255,0.04)", borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.08)",
            }}>
              <div>
                <p style={{ margin: "0 0 3px", color: "#e6e8ee", fontSize: 13, fontWeight: 600 }}>
                  Cookie-uri esențiale
                </p>
                <p style={{ margin: 0, color: "rgba(203,213,225,0.65)", fontSize: 12, lineHeight: 1.5 }}>
                  Token autentificare (JWT), preferințe interfață, consimțământ cookies. Necesare pentru funcționarea platformei — nu pot fi dezactivate.
                </p>
              </div>
              <span style={{
                flexShrink: 0, padding: "3px 10px", borderRadius: 20,
                background: "rgba(52,211,153,0.15)", color: "#34d399",
                fontSize: 11, fontWeight: 700, marginTop: 2,
              }}>
                Mereu active
              </span>
            </div>

            {/* Analytics — opțional */}
            <div style={{
              display: "flex", alignItems: "flex-start", justifyContent: "space-between",
              gap: 16, padding: "12px 16px",
              background: "rgba(255,255,255,0.04)", borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.08)",
            }}>
              <div>
                <p style={{ margin: "0 0 3px", color: "#e6e8ee", fontSize: 13, fontWeight: 600 }}>
                  Cookie-uri analitice — Google Analytics 4
                </p>
                <p style={{ margin: 0, color: "rgba(203,213,225,0.65)", fontSize: 12, lineHeight: 1.5 }}>
                  Ne ajută să înțelegem ce pagini sunt vizitate și cum navigați pe site (_ga, _ga_*). Datele sunt anonime și agregate. Fără aceste cookie-uri, nu putem îmbunătăți platforma.
                </p>
              </div>
              {/* Toggle */}
              <button
                onClick={() => setAnalytics(v => !v)}
                aria-pressed={analyticsOn}
                aria-label="Activează/dezactivează cookie-uri analitice"
                style={{
                  flexShrink: 0, width: 44, height: 24, borderRadius: 12,
                  background: analyticsOn ? "#2B36A8" : "rgba(255,255,255,0.15)",
                  border: "none", cursor: "pointer", position: "relative",
                  transition: "background 0.2s", marginTop: 2,
                }}
              >
                <span style={{
                  position: "absolute", top: 3,
                  left: analyticsOn ? 23 : 3,
                  width: 18, height: 18, borderRadius: "50%",
                  background: "#fff", transition: "left 0.2s",
                }} />
              </button>
            </div>

            {/* Marketing/conversii — opțional */}
            <div style={{
              display: "flex", alignItems: "flex-start", justifyContent: "space-between",
              gap: 16, padding: "12px 16px",
              background: "rgba(255,255,255,0.04)", borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.08)",
            }}>
              <div>
                <p style={{ margin: "0 0 3px", color: "#e6e8ee", fontSize: 13, fontWeight: 600 }}>
                  Cookie-uri de marketing — Google Ads, Meta, LinkedIn
                </p>
                <p style={{ margin: 0, color: "rgba(203,213,225,0.65)", fontSize: 12, lineHeight: 1.5 }}>
                  Ne ajută să măsurăm dacă un vizitator venit dintr-o campanie a creat un cont sau a generat un raport și să-ți arătăm reclame relevante (remarketing) pe aceste platforme.
                </p>
              </div>
              {/* Toggle */}
              <button
                onClick={() => setMarketing(v => !v)}
                aria-pressed={marketingOn}
                aria-label="Activează/dezactivează cookie-uri de conversii"
                style={{
                  flexShrink: 0, width: 44, height: 24, borderRadius: 12,
                  background: marketingOn ? "#2B36A8" : "rgba(255,255,255,0.15)",
                  border: "none", cursor: "pointer", position: "relative",
                  transition: "background 0.2s", marginTop: 2,
                }}
              >
                <span style={{
                  position: "absolute", top: 3,
                  left: marketingOn ? 23 : 3,
                  width: 18, height: 18, borderRadius: "50%",
                  background: "#fff", transition: "left 0.2s",
                }} />
              </button>
            </div>

          </div>

          <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={() => save(analyticsOn, marketingOn)}
              style={{
                background: "#2B36A8", color: "#fff", border: "none",
                borderRadius: 8, padding: "10px 24px", fontSize: 13,
                fontWeight: 700, cursor: "pointer",
              }}
            >
              Salvează preferințele
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
